export const GET_AUDIT_LOG_DATA = 'system-info/GET_AUDIT_LOG_DATA';
export const TOGGLE_AUDIT_LOG_TABLE_LOADING = 'system-info/TOGGLE_AUDIT_LOG_TABLE_LOADING';

export const CHANGE_PAGINATION = 'system-info/CHANGE_PAGINATION';
export const CHANGE_FILTER = 'system-info/CHANGE_FILTER';

export const GET_SYSTEM_SETTINGS_DATA = 'system-info/GET_SYSTEM_SETTINGS_DATA';
export const GET_FEATURE_FLAGS_DATA = 'system-info/GET_FEATURE_FLAGS_DATA';
export const SET_FEATURE_FLAG_DATA = 'system-info/SET_FEATURE_FLAG_DATA';
export const TOGGLE_FEATURE_FLAGS_LOADING = 'system-info/TOGGLE_FEATURE_FLAGS_LOADING';
export const COLLECT_SYSTEM_SETTINGS_REQUEST_DATA = 'system-info/COLLECT_SYSTEM_SETTINGS_REQUEST_DATA';
export const TOGGLE_SYSTEM_SETTINGS_LOADING = 'system-info/TOGGLE_SYSTEM_SETTINGS_LOADING';

export const SET_TEST_EMAIL_MODAL_STATE = 'system-info/SET_TEST_EMAIL_MODAL_STATE';
